import { d as defineCustomElement } from '../chunks/vidstack-DoOmgEfT.js';
import { a as MediaPlayerElement, M as MediaProviderElement } from '../chunks/vidstack-Vw-d0U2k.js';
import '../chunks/vidstack-D1JzjGR7.js';
import '../chunks/vidstack-awVFxJvn.js';
import '../chunks/vidstack-CerDQCFL.js';
import '../chunks/vidstack-B_9E7csz.js';
import '../chunks/vidstack-BYuWkQD6.js';
import '../chunks/vidstack-CMz4Bd8X.js';
import '../chunks/vidstack-i0oJKwBM.js';
import '../chunks/vidstack-CyIpzU-o.js';
import '../chunks/vidstack-B3EgHpRH.js';
import '../chunks/vidstack-2fIzRyOW.js';
import '../chunks/vidstack-XO9MYVWR.js';
import '../chunks/vidstack-ksPACRiU.js';

defineCustomElement(MediaPlayerElement);
defineCustomElement(MediaProviderElement);
